import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'sobName',
                label: '即征即退有效期',
                type: "datetimerange",
                valueformat:'yyyy-MM-dd'
            },
            {
                prop: 'bsType',
                label: '备案日期',
                type: "datetimerange",
                valueformat:'yyyy-MM-dd'
            },
            {
                prop: 'defaulted',
                label: '状态',
                type: 'select',
                selectval: comMapping.$flag
            },
            {
                prop: 'nsrmc',
                label: '软件名称',
                type: 'input'
            },
            {
                prop: 'sobExplain',
                label: '著作权登录日期',
                type: "datetimerange",
                valueformat:'yyyy-MM-dd'
            }
        ],
        searchdata: {
            sobName: '',
            bsType: '',
            defaulted: '',
            nsrmc: '',
            sobExplain: ''
        },
        headData: [
            {
                title: '软件名称',
                prop: 'sobName',
                width: 110,
                custom: true

            },
            {
                title: '著作权号',
                prop: 'bsType',
                width: 130,
                custom: true

            },
            {
                title: '状态',
                prop: 'defaulted',
                width: 50,
                custom: true

            },
            {
                title: '著作权登记日期',
                prop: 'nsrmc',
                width: 130,
                custom: true

            },
            {
                title: '即征即退有效期起',
                prop: 'sobExplain',
                width: 160,
                custom: true

            },
            {
                title: '即征即退有效期止',
                prop: 'sobExplain1',
                custom: true,
                width: 160
            },
            {
                title: '备案日期',
                prop: 'sobExplain2',
                custom: true,
                width: 200
            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 100
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
